module.exports = __webpack_public_path__ + "/images/nosotros-equipo.bef1851.jpg";